import React, {useState} from "react";
import PropTypes from "prop-types";

import {i18nFormat} from "../../lib/i18nFormat";

import {ContextMenu} from "../../components/ContextMenu";

export function SelfHostedServerContextButton(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [anchorElement, setAnchorElement] = useState(null);

  function toggle(event) {
    setAnchorElement(event.currentTarget);
    setIsOpen(prevState => !prevState);
  }

  function close() {
    setIsOpen(false);
  }

  function handleDeleteClick() {
    close();
    props.onDelete?.();
  }

  function handleEditCustomDomainClick() {
    close();
    props.onEditCustomDomain?.();
  }

  return (
    <React.Fragment>
      <button className="account-shs-context-button glyph-core-ellipsis" onClick={toggle} aria-haspopup="menu"
              aria-expanded={isOpen}/>
      <ContextMenu isOpen={isOpen} anchorElement={anchorElement} onClose={close}>
        {props.onEditCustomDomain && (
          <button type="button" className="account-context-menu__item" onClick={handleEditCustomDomainClick}>
            <span className="glyph-core-globe"/>
            <span>{i18nFormat("shs.context-menu.edit-custom-domain")}</span>
          </button>
        )}
        {props.onDelete && (
          <button type="button" className="account-context-menu__item account-context-menu__item--delete" onClick={handleDeleteClick}>
            <span className="glyph-core-trash-fill"/>
            <span>{i18nFormat("shs.context-menu.delete-server")}</span>
          </button>
        )}
      </ContextMenu>
    </React.Fragment>
  );
}

SelfHostedServerContextButton.propTypes = {
  onEditCustomDomain: PropTypes.func,
  onDelete: PropTypes.func,
};